import { FC } from 'react';
import {
  BooleanField,
  CreateButton,
  Datagrid,
  DateField,
  EditButton,
  List,
  TextField,
  TopToolbar,
  ReferenceField,
} from 'react-admin';

const ListActions = () => (
  <TopToolbar>
    <CreateButton label="Добавить продукт" />
  </TopToolbar>
);

export const ProductList: FC = () => (
  <List title="Список продуктов" filter={{}} actions={<ListActions />}>
    <Datagrid rowClick="show">
      <TextField source="id" label="ID" />
      <ReferenceField
        source="category_id"
        reference="categories"
        label="Категория"
      >
        <TextField source="name" />
      </ReferenceField>
      <TextField source="article" label="Артикуль" />
      <TextField source="name" label="Имя" />
      <TextField source="price" label="Цена" />
      <TextField source="count" label="Количество" />
      <BooleanField source="is_active" label="Активен" />
      <DateField source="created_at" label="Создан" locales={['ru']} />
      <DateField source="updated_at" label="Изменен" locales={['ru']} />
      <EditButton label="Редактировать" />
    </Datagrid>
  </List>
);
